import { render, staticRenderFns } from "./MasterDetail.vue?vue&type=template&id=61664c36&scoped=true"
import script from "./MasterDetail.vue?vue&type=script&lang=js"
export * from "./MasterDetail.vue?vue&type=script&lang=js"
import style0 from "./MasterDetail.vue?vue&type=style&index=0&id=61664c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61664c36",
  null
  
)

export default component.exports